// Module
var code = "<div id=\"drawerBackdrop\" class=\"drawer-backdrop\" ng-click=\"close()\"></div>";
// Exports
export default code;